import mainBannerImgDesktop from "/assets/images/webp/mainBannerImgDesktop.webp";
import mainBannerImgMobile from "/assets/images/webp/mainBannerImgMobile.webp";
import type { FC } from "react";
import { InstallOnChrome } from "@/features/installOnChrome";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import type { IBanner } from "../config";

/**
 * Главный баннер
 * @param baseClass
 * @param extraClasses
 * @param extraAttrs
 * @param utilClasses
 * @constructor
 */
export const Banner: FC<IBanner & IComponentBaseProps> = ({
  baseClass = "banner",
  extraClasses = "",
  extraAttrs = {},
  utilClasses = [],
}) => {
  const { getCN } = useCN(baseClass);

  return (
    <section className={getCN("", extraClasses, [ `relative bg-codGray text-white min-h-218 h-[100dvh] flex ${utilClasses ?? ""}` ])} {...extraAttrs}>
      <div className={getCN("inner")}>
        <div className={getCN("bg")}>
          <picture className={getCN("bgImg")}>
            <source srcSet={mainBannerImgMobile} media={"(max-width: 720px)"} />
            <source srcSet={mainBannerImgDesktop} media={"(min-width: 721px)"} />
            <img draggable={false} src={mainBannerImgDesktop} decoding={"async"} alt={"DeepSum"} />
          </picture>
        </div>
        <div className={getCN("innerText", {}, [ " -translate-y-[-11%]" ])}>
          <h1 className={getCN("title", {}, [ "h1", "isGradientText" ])}>
            AI-powered<br />
            video<br />
            summarizer
          </h1>
          <p className={getCN("description", {}, [ "subtitle" ])}>Designed for curious minds, powered by DeepSum intelligence.</p>
          <InstallOnChrome typeStyle={"base"} />
        </div>
      </div>
    </section>
  );

};
